import { render, staticRenderFns } from "./GetVehicleTableDataComponent.vue?vue&type=template&id=735587bf&scoped=true&"
import script from "./GetVehicleTableDataComponent.vue?vue&type=script&lang=js&"
export * from "./GetVehicleTableDataComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735587bf",
  null
  
)

export default component.exports